import { z } from 'zod';
import { uuid, isoDateTime } from './common.js';
/** The figures behind the overview page. All counts are for the whole account; the floor figures per warehouse come later. */
export const dashboardDto = z.object({
    today: z.object({
        ordersIn: z.number().int(),
        ordersInYesterday: z.number().int(),
        shipped: z.number().int(),
        shippedYesterday: z.number().int(),
    }),
    open: z.object({
        newOrders: z.number().int(),
        needsCheck: z.number().int(),
        onHold: z.number().int(),
        toPick: z.number().int(),
        toPack: z.number().int(),
        released: z.number().int(),
    }),
    /** Last 14 days, oldest first. */
    days: z.array(z.object({ day: z.string(), ordersIn: z.number().int(), shipped: z.number().int() })),
    shops: z.object({
        continuous: z.number().int(),
        batch: z.number().int(),
        closingSoon: z.array(z.object({ id: uuid, name: z.string(), closesAt: z.string().nullable(), openOrders: z.number().int() })),
    }),
    stock: z.object({ variantsWithStock: z.number().int(), onHand: z.number().int(), reserved: z.number().int(), navisionItems: z.number().int(), navisionFetchedAt: isoDateTime.nullable() }),
    feed: z.object({ enabled: z.boolean(), lastSuccessAt: isoDateTime.nullable(), lastOk: z.boolean().nullable(), backfillDone: z.boolean() }),
    system: z.object({ version: z.string(), ok: z.boolean() }),
});
//# sourceMappingURL=dashboard.js.map